export default __webpack_public_path__ + "static/media/zbo.39a7a642.svg";